





























import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class GlobalFooter extends Vue {
  /* TODO: Move data to service */
  private disclaimerText: string = 'Doc Danko® is owned by Seedspan ©2019 All rights reserved. Please enjoy responsibly. Do not operate vehicles or the machine while under the influence of Doc Danko\'s® Elixers, edibles or any other fine cannabis product.';
  private data() {
    return {
      socialLinks:
      [
        {
          url: 'http://facebook.com',
          icon: 'fa-facebook-f',
          target: '_blank',
        },
        {
          url: 'http://youtube.com',
          icon: 'fa-youtube',
          target: '_blank',
        },
        {
          url: 'http://twitter.com',
          icon: 'fa-twitter',
          target: '_blank',
        },
        {
          url: 'http://instagram.com',
          icon: 'fa-instagram',
          target: '_blank',
        },
      ],
    };
  }
}
